// import React from "react";
// import TotalRandomizationChart from "./Chart/TotalRandomizationChart";
// import SubjectRandomizationStatusChart from "./Chart/SubjectRandomizationStatusChart";
// import { FaListOl } from "react-icons/fa";
import { Card, Col, Container, Form, Row } from "react-bootstrap";
import CDISCDashboard from "./CDISCRecentActivity";

const ModeWiseCDISCGraph = ({ StudyMode }) => {
  const roleType = JSON.parse(localStorage.getItem("role"));
  return (
    <>
      <Container fluid>
        {/* <Row>
          <Form.Group as={Col} md={6} sm={12}>
            <Card className="mb-3 bg-light border">
              <Card.Body>
                <div className="d-flex gap-3">
                  <div className="study_icopn">
                    <FaListOl className="bg-white shadow-sm" />
                  </div>
                  <div>
                    <Card.Title>Total Randomizer</Card.Title>
                    <Card.Text className="m-0">5</Card.Text>
                    <Card.Text>2 new lar was added in past 1 month.</Card.Text>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Form.Group>
        </Row> */}
        <Row>
          {/* <Form.Group as={Col} md={6} className="mb-2">
            <div className="doughtnutClass border bg-light">
              <div className="radiobar__chart__graph pt-3">
                <h2 className="fontSize12" style={{ fontWeight: 500 }}>
                  Total Randomizer Data
                </h2>
              </div>
              <TotalRandomizationChart />
            </div>
          </Form.Group>
          <Form.Group as={Col} md={6} className="mb-2">
            <div className="doughtnutClass border bg-light">
              <div className="radiobar__chart__graph pt-3">
                <h2 className="fontSize12" style={{ fontWeight: 500 }}>
                  Subject Randomization Status
                </h2>
              </div>
              <SubjectRandomizationStatusChart />
            </div>
          </Form.Group> */}
          {roleType === "ctms" && (
            <Form.Group as={Col} md="12" className="mb-2">
              <Card className="border bg-light">
                <Card.Body>
                  <Card.Title>Recent activity</Card.Title>
                  <Card.Text className="m-0 mt-2">
                    <CDISCDashboard StudyMode={StudyMode} />
                  </Card.Text>
                </Card.Body>
              </Card>
            </Form.Group>
          )}
        </Row>
      </Container>
    </>
  );
};

export default ModeWiseCDISCGraph;
